// ContactForm.jsx
import React, { useRef, useState } from 'react'
import './ContactForm.scss';
import BreadCrumb from '../../../../components/BreadCrumb/BreadCrumb';
import emailjs from '@emailjs/browser';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';

const ContactForm = () => {


  const partnerDetail = useSelector((state) => state.partner.user);
  console.log("wyy",partnerDetail)
  const [loading, setLoading] = useState(false)
  


  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  React.useEffect(() => {
    if (partnerDetail) {
      setFormData({
        name: partnerDetail.name || '',
        email: partnerDetail.email || '',
        phone: partnerDetail.partner.contact_number || '',
        message: ''
      });
    }
  }, [partnerDetail]);
    

  const sendEmail = (e) => {
    e.preventDefault();
  
    const { email, name, phone, message } = formData;
  
    if (!email || !phone || !name || !message) {
      toast.error('Please enter required fields!');
      return;
    }
  
    setLoading(true);
  
    const templateParams = {
      email,
      phone,
      name,
      message: message || '',
    };
  
    emailjs
      .send('service_sbbbwwj', 'template_mxcx75b', templateParams, {
        publicKey: '5nEveGMS-YX46f7HA',
      })
      .then(
        () => {
          setLoading(false);
          toast.success('Your Response has been recorded Successfully!');
          setFormData({ name: '', email: '', phone: '', message: '' }); // Reset form
        },
        (error) => {
          setLoading(false);
          toast.error('Server Error! Please try again later!');
          console.log(error);
        }
      );
  };
  













  return (
    <>
    <div>
        <BreadCrumb paths={[{name:'Home',path:'/dashboard'},{name:"Contact Us",path:"/dashboard/contact-us"}]}/>
    </div>
    <div className="contact-form">
      <h2>Contact Us</h2>
      <p className="form-description">Fill out your details.</p>
      <form   onSubmit={sendEmail}  >
        <div className="form-group">
          <label>Name</label>
          <input type="text" placeholder="Adam"  name='name'    value={formData.name}
  onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
        </div>
        <div className="form-group">
          <label>Email address</label>
          <input type="email" placeholder="aman@lodha.co.in" name="email"   value={formData.email}
  onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
        </div>
        <div className="form-group">
          <label>Phone Number</label>
          <input type="text" placeholder="Enter Phone Number"  name="phone"   value={formData.phone}
  onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
        </div>
        <div className="form-group">
          <label>Message to client</label>
          <textarea
          name='message'
            rows="4"
            placeholder="Hey Adam! How have you been?  I wanted to ask you if you would'nt mind writing a testimonial of my work with you? Thanks!"
            value={formData.message}
            onChange={(e) => setFormData({ ...formData, message: e.target.value })}    ></textarea>
        </div>
        <div className="form-actions">
          <button type="button" className="cancel-btn" onClick={() => setFormData({ name: '', email: '', phone: '', message: '' })}   >Cancel</button>
          <button 
  type="submit" 
  className="submit-btn" 
  disabled={loading}  
  style={{
    position: 'relative', 
  }}
>
  {loading ? (
    <CircularProgress
      size={24}
      style={{
        color: '#00FF76', 
        position: 'absolute', 
        left: '50%',
        top: '50%',
        marginLeft: '-12px', 
        marginTop: '-12px',  
      }}
    />
  ) : (
    "Send Request"
  )}
</button>

        </div>
      </form>
    </div>
    </>
  );
};

export default ContactForm;
